
import Icon from '@material-ui/icons/AssignmentInd';
import List from './Userslist'


export default {
    list: List,
    icon: Icon,
};   
